import { OpenPanel } from '@openpanel/web'

import { getEnvironment } from './role-utils'

const apiUrl = import.meta.env.VITE_OPEN_PANEL_API_URL
const clientId = import.meta.env.VITE_OPEN_PANEL_CLIENT_ID

const currentEnvironment = getEnvironment()
const shouldTrackEvents =
  currentEnvironment === 'platform' || currentEnvironment === 'demo'

export const op = new OpenPanel({
  apiUrl,
  clientId,
  trackAttributes: true,
  trackScreenViews: true,
  trackOutgoingLinks: true,
  disabled: !shouldTrackEvents,
})
